var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiderbarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 1143,
    viewBox: "0 0 378 1143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 1143,
    fill: "url(#paint0_angular_449_3993)",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 1143,
    fill: "url(#paint1_angular_449_3993)",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_449_3993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.49607e-06 505) rotate(90) scale(638 210.992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.413518,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657178,
    stopColor: "#0275A2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988518,
    stopColor: "#0074A1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_449_3993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(378 598.5) rotate(101.219) scale(555.107 149.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148537,
    stopColor: "#0074A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825011,
    stopColor: "#0074A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiderbarBg);
export default __webpack_public_path__ + "static/media/SiderbarBg.f30a3f499c830296264ea8ceff33c72f.svg";
export { ForwardRef as ReactComponent };